import React, { memo, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TrackingAPI from "api/TrackingAPI";
import { Spinner } from 'components/ira/ui/Spinner';
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { GUEST_ROUTES } from 'routes/routes';
import styled from "styled-components";
import { ICharacter } from 'types/characters';

import { useGetCharactersQuery } from "../../../services/api/charactersApi";
import CharacterCard from "./components/CharacterCard";

const CharactersListApp = () => {

  const hasTrackedRef = useRef(false);
  const { data: characters = [] as ICharacter[], isLoading } = useGetCharactersQuery();

  const navigate = useNavigate();
  const charactersListFlag = useFeatureFlag('charactersList');

  useEffect(() => {
    const trackEvent = () => {
      if (hasTrackedRef.current) return;
      hasTrackedRef.current = true;

      try {
        TrackingAPI.trackEvent('characters_list_page_view');
      } catch (error) {
        throw error;
      }
    };

    trackEvent();
  }, []);

  useEffect(() => {
    if (!charactersListFlag) {
      navigate(GUEST_ROUTES.ROOT());
    }
  }, [charactersListFlag]);

  if (isLoading) {
    return (
      <SpinnerContainer>
        <Spinner size={100} />
      </SpinnerContainer>
    );
  }

  return (
    <Root>
      {characters.map((character) => (
        <CharacterCard key={character.id} character={character as ICharacter} />
      ))}
    </Root>
  );
};

export default memo(CharactersListApp);

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 308px);
  gap: 16px;
  justify-content: center;
  padding: 20px;

  @media (max-width: 1330px) {
    grid-template-columns: repeat(3, 308px);
  }

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 308px);
    justify-content: space-between;
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, auto);
    justify-content: center;
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
